<template>
  <div>
    <all-attendee-table
      @editAttendee="editAttendee"
    />
    <v-dialog
      persistent
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      scrollable
      v-model="editAttendeeModal"
    >
      <form-edit-attendee
        @close="closeForm"
        v-if="editAttendeeModal"
        :attendeTypesList="regularAttendeeTypeData"
        :attendee="editedAttendee"
        :attendeeFullInfo="attendeeFullInfo"
      />
    </v-dialog>

  </div>
</template>

<script>
import AllAttendeeTable from './AllAttendeeTable'
import FormEditAttendee from './FormEditAttendee'
import { mapActions, mapGetters } from 'vuex'
import { clone } from 'ramda'

export default {
  name: 'AllAttendee',
  components: {
    AllAttendeeTable,
    FormEditAttendee
  },
  data () {
    return {
      editAttendeeModal: false,
      editedAttendee: {},
      regularAttendeeTypeData: null,
      attendeeFullInfo: {}
    }
  },
  computed: {
    ...mapGetters([
      'regularAttendeeType'
    ])
  },
  watch: {
    regularAttendeeType: {
      handler (newVal) {
        this.regularAttendeeTypeData = clone(newVal)
      },
      immediate: true
    }
  },
  methods: {
    ...mapActions([
      'getRegularAttendeeType',
      'receiveFullAttendeeInfo'
    ]),
    async editAttendee(attendee) {
      try {
        this.attendeeFullInfo = clone(await this.receiveFullAttendeeInfo(attendee.id))
      } catch (err) {
        console.log('err', err)
      }
      this.editedAttendee = clone(attendee)
      this.editAttendeeModal = true
    },
    closeForm () {
      this.editAttendeeModal = false
      this.editedAttendee = {}
    }
  },
  async mounted () {
    try {
      await this.getRegularAttendeeType()
    } catch (err) {
      console.log('error', err)
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/pages/Registration/Attendee/AllAttendee/index.vue